import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, NavigationIcon, ExternalLinkIcon } from 'lucide-react';
export function LocationSection() {
  return <section id="lokalita" className="py-24 bg-slate-50 border-t border-slate-200" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-140">
          {/* Info Side */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-141">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-142">
              Lokalita
            </h2>

            <div className="flex items-start space-x-3 mb-8 text-slate-600 p-4 rounded-sm border border-slate-300 bg-slate-100" data-id="element-143">
              <MapPinIcon className="w-6 h-6 flex-shrink-0 mt-0.5 text-slate-500" data-id="element-144" />
              <p className="font-medium text-lg text-slate-700" data-id="element-145">
                Areál se nachází v centru města Žlutice, okres Karlovy Vary.
                Lokalita je strategicky umístěna s optimálními podmínkami pro
                podnikání. Do dvou let by měla být přivedena dálnice z Prahy,
                čímž se dojezd zkrátí na pouhých 40 minut.
              </p>
            </div>

            <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center" data-id="element-146">
              <NavigationIcon className="w-5 h-5 mr-2 text-slate-500" data-id="element-147" />
              Dojezdové vzdálenosti
            </h3>

            <ul className="space-y-3 mb-8" data-id="element-148">
              <li className="flex justify-between items-center py-2 border-b border-slate-200 pt-[8px] pb-[8px] pl-[50px] pr-[0px] gap-[0px]" data-id="element-149">
                <span className="font-medium text-slate-700" data-id="element-150">Praha</span>
                <span className="text-slate-500 bg-white px-3 py-1 rounded-full text-sm font-semibold shadow-sm border border-slate-100 text-right" data-id="element-151">
                  ~ 130 km (brzy 40 min po dálnici)
                </span>
              </li>
              <li className="flex justify-between items-center py-2 border-b border-slate-200 pl-[50px]" data-id="element-152">
                <span className="font-medium text-slate-700" data-id="element-153">Karlovy Vary</span>
                <span className="text-slate-500 bg-white px-3 py-1 rounded-full text-sm font-semibold shadow-sm border border-slate-100 text-right" data-id="element-154">
                  ~ 30 km
                </span>
              </li>
              <li className="flex justify-between items-center py-2 border-b border-slate-200 pl-[50px]" data-id="element-155">
                <span className="font-medium text-slate-700" data-id="element-156">Plzeň</span>
                <span className="text-slate-500 bg-white px-3 py-1 rounded-full text-sm font-semibold shadow-sm border border-slate-100 text-right" data-id="element-157">
                  ~ 80 km
                </span>
              </li>
              <li className="flex justify-between items-center py-2 pl-[50px]" data-id="element-158">
                <span className="font-medium text-slate-700" data-id="element-159">Cheb</span>
                <span className="text-slate-500 bg-white px-3 py-1 rounded-full text-sm font-semibold shadow-sm border border-slate-100 text-right" data-id="element-160">
                  ~ 75 km
                </span>
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-161">
              Dopravní obslužnost
            </h3>
            <p className="text-slate-600 pl-[50px]" data-id="element-162">
              Vlak, dálnice, silnice, MHD, autobus.
            </p>
          </motion.div>

          {/* Map Card Side */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-[400px] lg:h-[600px] w-full" data-id="element-163">
            <a href="https://www.google.com/maps/dir//50.0868341,13.1622311/@50.0869142,13.1612436,262m/data=!3m1!1e3!4m2!4m1!3e0!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDMxNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="block h-full w-full rounded-sm overflow-hidden shadow-lg border border-slate-200 relative group cursor-pointer" data-id="element-164">
              {/* Topographic-style background */}
              <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-slate-50 to-slate-200" data-id="element-165">
                {/* Decorative topographic lines */}
                <svg className="absolute inset-0 w-full h-full opacity-[0.15]" viewBox="0 0 400 600" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-166">
                  <path d="M0 100 Q100 80 200 120 T400 100" stroke="#64748b" strokeWidth="1" data-id="element-167" />
                  <path d="M0 140 Q120 110 220 150 T400 130" stroke="#64748b" strokeWidth="1" data-id="element-168" />
                  <path d="M0 180 Q80 160 180 200 T400 170" stroke="#64748b" strokeWidth="1" data-id="element-169" />
                  <path d="M0 220 Q140 190 240 230 T400 210" stroke="#64748b" strokeWidth="1" data-id="element-170" />
                  <path d="M0 260 Q100 240 200 280 T400 250" stroke="#64748b" strokeWidth="1" data-id="element-171" />
                  <path d="M0 300 Q130 270 230 310 T400 290" stroke="#64748b" strokeWidth="1" data-id="element-172" />
                  <path d="M0 340 Q90 320 190 360 T400 330" stroke="#64748b" strokeWidth="1" data-id="element-173" />
                  <path d="M0 380 Q110 350 210 390 T400 370" stroke="#64748b" strokeWidth="1" data-id="element-174" />
                  <path d="M0 420 Q140 400 240 440 T400 410" stroke="#64748b" strokeWidth="1" data-id="element-175" />
                  <path d="M0 460 Q80 440 180 480 T400 450" stroke="#64748b" strokeWidth="1" data-id="element-176" />
                  <path d="M0 500 Q120 470 220 510 T400 490" stroke="#64748b" strokeWidth="1" data-id="element-177" />
                  <path d="M0 540 Q100 520 200 560 T400 530" stroke="#64748b" strokeWidth="1" data-id="element-178" />
                  <path d="M0 580 Q130 550 230 590 T400 570" stroke="#64748b" strokeWidth="1" data-id="element-179" />
                  {/* Grid dots */}
                  {Array.from({
                  length: 20
                }).map((_, row) => Array.from({
                  length: 12
                }).map((_, col) => <circle key={`${row}-${col}`} cx={col * 35 + 15} cy={row * 32 + 10} r="1" fill="#94a3b8" data-id="element-180" />))}
                </svg>

                {/* Subtle radial glow behind pin */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-slate-300/30 rounded-full blur-3xl" data-id="element-181" />
              </div>

              {/* Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center z-10 p-8" data-id="element-182">
                {/* Pin icon with pulse */}
                <div className="relative mb-8" data-id="element-183">
                  <div className="absolute inset-0 w-20 h-20 bg-slate-400/20 rounded-full animate-ping" style={{
                  animationDuration: '3s'
                }} data-id="element-184" />
                  <div className="relative w-20 h-20 bg-white rounded-full shadow-lg border border-slate-200 flex items-center justify-center group-hover:shadow-xl group-hover:scale-110 transition-all duration-300" data-id="element-185">
                    <MapPinIcon className="w-10 h-10 text-slate-700 group-hover:text-slate-900 transition-colors" data-id="element-186" />
                  </div>
                </div>

                {/* Location text */}
                <h3 className="text-2xl font-bold text-slate-900 mb-2 text-center" data-id="element-187">
                  Žlutice
                </h3>
                <p className="text-slate-500 mb-8 text-center text-lg" data-id="element-188">
                  Karlovarský kraj, Česká republika
                </p>

                {/* CTA Button */}
                <div className="inline-flex items-center px-6 py-3 bg-slate-800 text-white rounded-sm font-medium shadow-md group-hover:bg-slate-900 group-hover:shadow-lg transition-all duration-300" data-id="element-189">
                  <span data-id="element-190">Zobrazit na mapě</span>
                  <ExternalLinkIcon className="w-4 h-4 ml-2 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-191" />
                </div>

                {/* Coordinates */}
                <p className="text-xs text-slate-400 mt-4 font-mono" data-id="element-192">
                  50.0997°N, 13.1657°E
                </p>
              </div>

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/5 transition-colors duration-300 z-[5]" data-id="element-193" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}